import { createSvgComponent } from "../../icon/createSvgComponent";
import ArrowdownFill from "@core/__generated__/icon/figma/arrowdown-fill.svg";
export default createSvgComponent(ArrowdownFill);